var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingPrivacy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 29.5469C15.5 29.5469 4.35938 28.0938 4.35938 7.26562L15.5 1.45312L26.6406 7.26562C26.6406 28.0938 15.5 29.5469 15.5 29.5469Z",
    fill: "#2978B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 27.6094C15.5 27.6094 6.29688 25.1875 6.29688 8.23438L15.5 3.39062L24.7031 8.23438C24.7031 25.1875 15.5 27.6094 15.5 27.6094Z",
    fill: "#3397E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23.7344C12.5574 23.7344 10.1719 21.3489 10.1719 18.4062V15.0156C10.1719 14.4806 10.6056 14.0469 11.1406 14.0469H19.8594C20.3944 14.0469 20.8281 14.4806 20.8281 15.0156V18.4062C20.8281 21.3489 18.4426 23.7344 15.5 23.7344Z",
    fill: "#FFD33A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1406 11.625V14.0469H13.0781V11.625C13.0781 10.2875 14.1625 9.20312 15.5 9.20312C16.8375 9.20312 17.9219 10.2875 17.9219 11.625V14.0469H19.8594V11.625C19.8594 9.21741 17.9076 7.26562 15.5 7.26562C13.0924 7.26562 11.1406 9.21741 11.1406 11.625Z",
    fill: "#E9EEF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 17.4375C16.9531 16.6043 16.2519 15.9349 15.4074 15.9872C14.68 16.0324 14.0896 16.627 14.0492 17.3547C14.0234 17.818 14.2151 18.2373 14.5312 18.5203V19.8594C14.5312 20.3945 14.9649 20.8282 15.5 20.8282C16.0351 20.8282 16.4687 20.3945 16.4687 19.8594V18.5203C16.766 18.2543 16.9531 17.8678 16.9531 17.4375Z",
    fill: "#FFB632"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingPrivacy);
export default __webpack_public_path__ + "static/media/setting_privacy.af44005443420399a08677b2c3b6744f.svg";
export { ForwardRef as ReactComponent };